export default {
  buttons: {
    remove: 'Verwijderen',
  },
  title: 'Promocode of cadeaubon',
};
